"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.updateSettingZendeskClassic = void 0;
//ZENDESK CLASSIC: Settings reference https://developer.zendesk.com/api-reference/widget/settings/#zindex
const updateSettingZendeskClassic = (command, data, onError) => {
  try {
    var _window$zE;
    if (!window.zE || ((_window$zE = window.zE) === null || _window$zE === void 0 ? void 0 : _window$zE.widget) !== 'classic') {
      return;
    }
    return window.zE('webWidget', command, data);
  } catch (error) {
    if (onError) onError(error);
  }
};
exports.updateSettingZendeskClassic = updateSettingZendeskClassic;